var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 17.497L34.4666 24.4637C33.0666 30.4804 30.3 32.9137 25.1 32.4137C24.2666 32.347 23.3666 32.197 22.4 31.9637L19.6 31.297C12.65 29.647 10.5 26.2137 12.1333 19.247L13.7666 12.2637C14.1 10.847 14.5 9.61369 15 8.59702C16.95 4.56369 20.2666 3.48035 25.8333 4.79702L28.6166 5.44702C35.6 7.08035 37.7333 10.5304 36.1 17.497Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1001 32.4138C24.0667 33.1138 22.7667 33.6972 21.1834 34.2138L18.5501 35.0805C11.9334 37.2138 8.45008 35.4305 6.30008 28.8138L4.16675 22.2305C2.03341 15.6138 3.80008 12.1138 10.4167 9.9805L13.0501 9.11383C13.7334 8.89717 14.3834 8.71383 15.0001 8.59717C14.5001 9.61383 14.1001 10.8472 13.7667 12.2638L12.1334 19.2472C10.5001 26.2138 12.6501 29.6472 19.6001 31.2972L22.4001 31.9638C23.3667 32.1972 24.2667 32.3472 25.1001 32.4138Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0667 14.314L29.15 16.364",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4333 20.7637L24.2667 21.997",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.6b95502a9ab8dec92340c546edd394ba.svg";
export { ForwardRef as ReactComponent };